import { createMutation, request } from '@luna/api';
import type { SignInfo } from '@shared/core-types';

import { getCDMUrl } from './ContactDataManagementApiService';

interface ContactsConfirmationResponse {
    signInfo?: SignInfo;
}

export const [useContactsConfirmation] = createMutation<ContactsConfirmationResponse>({
    name: 'contact-data-management/contact-confirmation',
    payloadCreator: () => request.post(`${getCDMUrl()}/confirmation`),
});
